﻿import $ from "jquery";

export function setupAddressLookup(parentSelector, loqateKey) {
    let addressLookups = $('[address-id]:not(:disabled)');
    if (parentSelector) {
        addressLookups = $(parentSelector).find('[address-id]');
    }

    addressLookups.each(function () {
        setupLoqate("#" + $(this).attr("address-id"), loqateKey);
        $(this).attr('address-setup', true);
    });
}

function setupLoqate(addressId, loqateKey) {
    let element = addressId.replace('#', '');
    let fullAddressInput = $(`${addressId}_FullAddress`)[0];
    if (!fullAddressInput) {
        return;
    }

    let addressName = fullAddressInput.getAttribute('name').replace('.FullAddress', '');
    let wrapper = $(`[name="${addressName}.Wrapper"]`);

    let addressFields = [
        { element: element + "_FullAddress", field: "Label", mode: pca.fieldMode.DEFAULT },
        { element: element + "_Flat", field: "SubBuilding", mode: pca.fieldMode.POPULATE },
        { element: element + "_HouseName", field: "BuildingName", mode: pca.fieldMode.POPULATE },
        { element: element + "_HouseNumber", field: "BuildingNumber", mode: pca.fieldMode.POPULATE },
        { element: element + "_Street", field: "Street", mode: pca.fieldMode.POPULATE },
        { element: element + "_SecondaryStreet", field: "Line3", mode: pca.fieldMode.POPULATE },
        { element: element + "_District", field: "District", mode: pca.fieldMode.POPULATE },
        { element: element + "_Town", field: "City", mode: pca.fieldMode.POPULATE },
        { element: element + "_County", field: "Province", mode: pca.fieldMode.POPULATE },
        { element: element + "_Postcode", field: "PostalCode", mode: pca.fieldMode.POPULATE },
        { element: element + "_Country", field: "CountryName", mode: pca.fieldMode.POPULATE },
        { element: element + "_Type", field: "Type", mode: pca.fieldMode.POPULATE },
        { element: element + "_Label", field: "Label", mode: pca.fieldMode.POPULATE }
    ];

    for (const field of addressFields.filter(address => !address.element.endsWith("_FullAddress"))) {
        $(`#${field.element}`).on('change', function () {
            updateFullAddress(addressId);
        });
    }

    let addressOptions = {
        key: loqateKey,
        countries: {
            codesList: "GB"
        },
        setCountryByIP: false
    }

    let addressControl = new pca.Address(addressFields, addressOptions);
    addressControl.listen("populate", function (_address, _addressVariations) {
        $(fullAddressInput).rules("remove", "addresspopulated");
        $(fullAddressInput).valid();
        $(addressId + '_FullAddress').parent().addClass("d-none");
        $(addressId + '_ManualButton').addClass("d-none");
        $(addressId + '_Result').removeClass("d-none");
        $(addressId + '_Type').valid();
    });

    addressControl.listen("show", function () {
        if (!$(fullAddressInput.form).validate().invalid.hasOwnProperty(fullAddressInput.name)) {
            $(fullAddressInput).rules("remove", "addresspopulated");
        }
    });

    addressControl.listen("hide", function () {
        if ($(':focus')[0] != $(fullAddressInput)[0]) {
            $(fullAddressInput).rules("add", {
                addresspopulated: {
                    target: addressId + 'Result'
                }
            });
            $(fullAddressInput).valid();
        }
    });

    wrapper.find('[data-button-type="ClearAddress"]').off('click').on('click', function () { clearAddress(addressId) });
    wrapper.find('[data-button-type="EnterManualAddress"]').off('click').on('click', function () { toggleManualEntry(addressId, true) });
    wrapper.find('[data-button-type="SearchForAddress"]').off('click').on('click', function () { toggleManualEntry(addressId, false) });
}

export function clearAddress(id) {
    $(id + '_FullAddress').val('');
    $(id + '_Label').val('');
    $(id + '_Result input').val('');
    $(id + '_Result').addClass("d-none")
    $(id + '_Search').removeClass("d-none");
    $(id + '_FullAddress').parent().removeClass("d-none");
    $(id + '_ManualButton').removeClass("d-none");
    $(id + '_SearchButton').addClass("d-none");

    let name = id.replace('#', '').replace('_', '.')
    $('[data-valmsg-for="' + name + '.ValidAddress"]').empty();
    $('[data-valmsg-for="' + name + '.Unique"]').removeClass('field-validation-error').text('');
}

export function toggleManualEntry(id, show) {
    $(id + '_ManualInputs').toggleClass("d-none", !show);
    $(id + '_SearchButton').toggleClass("d-none", !show);
    $(id + '_ManualButton').toggleClass("d-none", show);
    $(id + '_FullAddress').parent().toggleClass("d-none", show);
    $(`[id^=${id.replace('#', '')}]`).each(function () {
        emptyAndClearValidation(this.getAttribute("id"));
    });

    $(id + '_ManualEntry').val(show ? 'True' : 'False');
    $(id + '_ManualEntry').trigger('change');
}

function emptyAndClearValidation(elementId) {
    let element = $("#" + elementId);
    let validationSpan = $("#" + elementId + " ~ span")
    element.val('');
    element.removeClass("input-validation-error");
    validationSpan.removeClass("field-validation-error");
    validationSpan.addClass('field-validation-valid');
}

function updateFullAddress(id) {
    let addressFields = ['_Flat', '_HouseNumber', '_HouseName', '_Street', '_Town', '_Postcode', '_Country'];
    let fullAddress = addressFields.map(field => $(id + field).val()).filter(field => field).join(',');
    $(id + '_FullAddress').val(fullAddress);
}